import ApiBase from "./ApiBase";

class ProductApi {
  fetchAll(query, rule = "complete_active") {
    return ApiBase.get("/products/search", {
      query,
      rule,
    });
  }
}

export default new ProductApi();
